import React from "react";
import Carousel, { CarouselItem } from "./Carousel";
import streak from './streak.png'
 

export default function Stats() {
  return (
    <Carousel>
      {/* <CarouselItem>
         
        <img className="stat_img" alt = "Git_stats" src='https://camo.githubusercontent.com/01f015f07b751a1e996ad3067a1afbdabe9e6a41493a8d86bb0b4c82a6bde069/68747470733a2f2f6769746875622d726561646d652d73746174732e76657263656c2e6170702f6170693f757365726e616d653d73686976616e73682d736f6e6930372673686f775f69636f6e733d74727565266c6f63616c653d656e'  />
        
      </CarouselItem> */}
      <CarouselItem> 
        <img  className="stat_img"  alt = "Git_stats" src='https://github-readme-streak-stats.herokuapp.com/?user=shivansh-soni07&theme=default&hide_border=false' />
      </CarouselItem>
      <CarouselItem>
       
        <img className="stat_img" alt = "Leetcode_stats" src='https://leetcode.card.workers.dev/Shivansh_07?theme=default&font=baloo&extension=null' />
      </CarouselItem>
      <CarouselItem>
       
        <img className="stat_img" alt = "Leetcode_streak" src={streak} />
      </CarouselItem>
    </Carousel>
  );
}
